const CONTROLLED = { label: "Controlled path", amount: "c. £15,000 / five years", value: 15 };
const DEPENDENCY = { label: "Dependency / uncontrolled path", amount: "potentially c. £20,000–£24,000+ / five years", value: 24 };
const MAX = 24;

export const CostComparison = () => (
  <div className="cost-comparison" data-testid="cost-comparison">
    <div className="cost-row">
      <div className="cost-row-label">{CONTROLLED.label}</div>
      <div className="cost-row-amount">{CONTROLLED.amount}</div>
      <div className="cost-bar-track">
        <div className="cost-bar controlled" style={{ width: `${(CONTROLLED.value / MAX) * 100}%` }} />
      </div>
    </div>
    <div className="cost-row">
      <div className="cost-row-label">{DEPENDENCY.label}</div>
      <div className="cost-row-amount">{DEPENDENCY.amount}</div>
      <div className="cost-bar-track">
        <div className="cost-bar dependency" style={{ width: `${(DEPENDENCY.value / MAX) * 100}%` }} />
      </div>
    </div>
    <p className="cost-comparison-caption">The difference is capability, not licence cost.</p>
  </div>
);
